import { getLocale } from "../runtime";

const sv_whichvariant = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vilken variant vill du ha?`
};

const whichvariant = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_whichvariant(inputs)
	return "whichVariant";
};

export { whichvariant as "whichVariant" };